var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.677,
    height: 28,
    viewBox: "0 0 31.677 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(-1.9 -7.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9497",
    "data-name": "Path 9497",
    d: "M38.523,45.531l5.065-5.452a1.52,1.52,0,0,0-.065-2.129h0a1.52,1.52,0,0,0-2.129.065l-3.968,4.29L35.62,40.37a1.506,1.506,0,1,0-2.194,2.065l2.9,3.129A1.511,1.511,0,0,0,38.523,45.531Z",
    transform: "translate(-20.736 -19.947)",
    fill: "#fff",
    stroke: "#5a8746",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9498",
    "data-name": "Path 9498",
    d: "M30.594,18.1h-1a12.046,12.046,0,0,0-23.742,0H4.884A2.506,2.506,0,0,0,2.4,20.584v4.161a2.463,2.463,0,0,0,.742,1.774,2.551,2.551,0,0,0,1.742.71H7.11a1.156,1.156,0,0,0,1.161-1.161V20.132a9.419,9.419,0,0,1,18.839,0v8.1A3.882,3.882,0,0,1,23.239,32.1H21.11a1.5,1.5,0,0,0-1.484-1.161H15.787a1.549,1.549,0,0,0-1.548,1.548v1.065A1.549,1.549,0,0,0,15.787,35.1h3.9a1.587,1.587,0,0,0,1.484-1.161H23.3a5.72,5.72,0,0,0,5.71-5.71V27.2h1.581a2.493,2.493,0,0,0,1.742-.71,2.463,2.463,0,0,0,.742-1.774V20.584A2.506,2.506,0,0,0,30.594,18.1Z",
    fill: "#fff",
    stroke: "#5a8746",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu12);
export default __webpack_public_path__ + "static/media/menu-12.6ba7484628f3b1da09bc041a0fe188d2.svg";
export { ForwardRef as ReactComponent };